import './TradesBlotter.scss';
import { ServerSideBlotterSearchRequest } from 'apiConnector/blotters';
import classnames from 'classnames';
import { GridByType } from 'components/Blotters/Trades/Grid/grid-by-type';
import { BlotterPanel } from 'components/shared/Blotter/BlotterPanel/BlotterPanel.connect';
import { useAppSelector } from 'hooks/useAppSelector';
import { PropsWithChildren, useState } from 'react';
import { isBlotterPanelItemActive } from 'state/blotters/blotterPanel/blotterPanel.selector';

import { ConnectedTradesBlotterFilter } from './Filter/Filter';
import { PreferencesLoadingErrorModal } from './preferences-loading-error-modal';

function BlotterWrapper({ children }: PropsWithChildren) {
  const className = useAppSelector(state => {
    const isActive = isBlotterPanelItemActive(state);
    return classnames('d-flex flex-column p-0', {
      'col-md-6 col-lg-8 col-xl-9 col-xxl-9': isActive,
      'col-12': !isActive,
    });
  });

  return <div className={className}>{children}</div>;
}
function PanelWrapper({ children }: PropsWithChildren) {
  return (
    useAppSelector(isBlotterPanelItemActive) && (
      <div className="col-md-6 col-lg-4 col-xl-3 col-xxl-3 px-0">{children}</div>
    )
  );
}
export function Blotter() {
  const [lastBlotterRequest, setLastBlotterRequest] = useState<ServerSideBlotterSearchRequest>();

  return (
    <PreferencesLoadingErrorModal>
      <div className="container-fluid px-0 h-100 gap-4" data-e2e="trade-blotter-container">
        <div className="d-flex flex-column h-100">
          <div className="d-flex flex-row bg-lvl1 flex-wrap">
            <ConnectedTradesBlotterFilter lastBlotterRequest={lastBlotterRequest} />
          </div>
          <div className="d-flex flex-grow-1 flex-row min-h-0 vh-100">
            <BlotterWrapper>
              <GridByType setLastBlotterRequest={setLastBlotterRequest} />
            </BlotterWrapper>
            <PanelWrapper>
              <BlotterPanel />
            </PanelWrapper>
          </div>
        </div>
      </div>
    </PreferencesLoadingErrorModal>
  );
}
